import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrophy } from '@fortawesome/free-solid-svg-icons'
import classNames from 'classnames'
import { FormattedMessage } from 'locales/index'
import React from 'react'
import { Layout } from '@commutifi-fe/ui'
import styles from './styles.module.scss'

const { Header, Content } = Layout

interface IRegisterHeadlineProps {
  // Overwrite the title
  title?: React.ReactNode
  // Overwrite the subTitle
  subTitle?: React.ReactNode
}
export interface IRegisterScreenLayoutProps extends IRegisterHeadlineProps {
  children: React.ReactNode
  // Display any header on top of the register form card with the title and subTitle
  header?: React.ReactNode
}

function RegisterHeadline({ title, subTitle }: IRegisterHeadlineProps) {
  return (
    <div className={classNames(styles.headline)}>
      <div className={styles.icon}>
        <FontAwesomeIcon icon={faTrophy} className="u-color--primary" />
      </div>
      <div className={styles.title}>
        {title || <FormattedMessage id="components.registerScreen.directOnboarding.title" />}
      </div>
      <div className={styles.subtitle}>
        {subTitle || (
          <>
            <span className="u-font-weight-semi">
              <FormattedMessage id="components.registerScreen.directOnboarding.subtitle" />
            </span>
            <FormattedMessage id="components.registerScreen.directOnboarding.subtitle.2" />
          </>
        )}
      </div>
    </div>
  )
}

function RegisterScreenLayout({ children, header, title, subTitle }: IRegisterScreenLayoutProps) {
  return (
    <Layout className="layout">
      <div className={styles['layout-inner-content']}>
        <Header className="header">
          <div className="u-flex-column u-flex-1">
            {header}
            <RegisterHeadline title={title} subTitle={subTitle} />
          </div>
        </Header>
        <Content className="content">{children}</Content>
      </div>
    </Layout>
  )
}

export default RegisterScreenLayout
